import { render, staticRenderFns } from "./ScrollTopComponent.vue?vue&type=template&id=61d1e9f2&scoped=true&"
import script from "./ScrollTopComponent.vue?vue&type=script&lang=js&"
export * from "./ScrollTopComponent.vue?vue&type=script&lang=js&"
import style0 from "./ScrollTopComponent.vue?vue&type=style&index=0&id=61d1e9f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d1e9f2",
  null
  
)

export default component.exports